import React from "react";
import { updateVacationBeingHere } from "../../api/VacationBeingHere";
import Swal from "sweetalert2";

const EditVacationBeingHere = ({ vacationBeingHere, onSuccess }) => {
  const [vacationBeingHereDetails, setVacationBeingHereDetails] =
    React.useState({
      id: "",
      name: "",
      introduction: "",
    });

  React.useEffect(() => {
    setVacationBeingHereDetails({
      id: vacationBeingHere?._id,
      name: vacationBeingHere?.name,
      introduction: vacationBeingHere?.introduction,
    });
  }, [vacationBeingHere]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = updateVacationBeingHere(vacationBeingHereDetails);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Vacation Being Here Updated!",
            text: "You have successfully updated a vacation being here!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputComapanyName">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={vacationBeingHereDetails.name}
            onChange={(e) =>
              setVacationBeingHereDetails({
                ...vacationBeingHereDetails,
                id: vacationBeingHereDetails?.id,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputIntroduction">Introduction</label>
          <textarea
            className="form-control"
            id="exampleInputIntroduction"
            rows="3"
            name="introduction"
            value={vacationBeingHereDetails.introduction}
            onChange={(e) =>
              setVacationBeingHereDetails({
                ...vacationBeingHereDetails,
                id: vacationBeingHereDetails?.id,
                introduction: e.target.value,
              })
            }
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Update
        </button>
      </form>
    </>
  );
};

export default EditVacationBeingHere;
